import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";

import Loader from "../../Components/Loader";
import Principal from "../../Components/Blogs/Principal";

import "./Blog.css";
import blogHelper from "../../Helpers/Blogs";

import { useAuth } from "../../Context/Context";

const Profesores = (props) => {
  const { setEditar, editar } = useAuth();

  const [bandera, setBandera] = useState(false);
  const [blogs, setBlogs] = useState(false);

  useEffect(() => {
    obtenerBlogs();
  }, []);

  function createMarkup(materias) {
    return { __html: materias };
  }

  const obtenerBlogs = async () => {
    let res = await blogHelper.obtenerBlogs();
    if (res.success) {
      setTimeout(() => {
        setBlogs(res.data);
        setBandera(true);
      }, 1000);
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el evento, codigo: " + res.code,
        "error"
      );
    }
  };

  const agregarBlog = () => {
    let ventana = document.getElementById("ventana_editable_agregar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar_agregar");
    cerrar.className = "invisible_cerrar_activado";

    let ckedittor_contenedor = document.getElementById("ckedittor_contenedor");
    // NOTA: la variable editar la cual la estamos copiando, esta copia es como se encuentra en el ...
    // ... momento que se invoco el reactdom, si se hacen cambios despues de el reactdom se perderan estos cambios
    ReactDOM.render(
      <CKEditor
        editor={ClassicEditor}
        onChange={(event, editor) => {
          const data = editor.getData();
          setEditar({
            ...editar,
            contenido: data,
          });
        }}
      />,
      ckedittor_contenedor
    );
  };

  const actualizarBlog = (profesor, index, tipo) => {
    let ventana = document.getElementById("ventana_editable_editar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar");
    cerrar.className = "invisible_cerrar_activado";

    setEditar(profesor);
  };

  return (
    <div id="vistas_generales" className="col s12" style={{ padding: "0" }}>
      <div className="container">
        <p
          className="titulo_1_nv center"
          style={{ marginTop: "15px", color: "#00496c" }}
        >
          Blogs y Noticias
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="boton_2_nv">
          <button onClick={agregarBlog}>
            <p>Agregar Blog</p>
          </button>
        </div>
      </div>

      <div className="container center" style={{ marginTop: "25px" }}>
        {!bandera ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
            }}
          >
            <Loader />
          </div>
        ) : (
          <Fragment>
            <div
              className="componente_editable_padre"
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                paddingBottom: "30px",
              }}
            >
              {blogs.map((blog) => (
                <Principal blog={blog} />
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Profesores;
